import React, { useState } from "react";
import {
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  CircularProgress
} from "@mui/material";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import { submitFormAPI } from "../Util/UtilApi";
// import ToastMessages from "../assets/commonComponents/ToastMessages";
import ToastMessages from "../assets/commonComponents/ToastMessages";

const Chatbot = () => {
  const [isSnackbarOpen, setSnackbarOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("enquiry");
  const [snackMessage, setSnackMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [loading,setLoading]=useState(false);
  // Single state object to store all form data
  const [formData, setFormData] = useState({
    title: "Mr",
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    company: "",
    phone: "",
    description: "",
    subject: "",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
      setFormData({
          title: "Mr",
        firstName: "",
        lastName: "",
        name: "",
        email: "",
        company: "",
        phone: "",
        description: "",
        subject: "",
    })
    setErrors({})
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateName = (name) => {
    const nameRegex =/^[A-Za-z\s]+$/;
    return nameRegex.test(name);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\d+$/; // Only digits allowed
    return phoneRegex.test(phone);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    let error = "";

    // Validate the field
    if (name === "email" && value && !validateEmail(value)) {
      error = "Invalid email address";
    } else if (
      (name === "firstName" || name === "lastName") &&
      value &&
      !validateName(value)
    ) {
      error = "Name must contain only letters";
    } else if (name === "phone" && value && !validatePhone(value)) {
      error = "Phone number must contain only numbers";
    }

    // Update errors state
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));

    // Always update form data state, even if validation fails
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateFields = () => {
    const { firstName, lastName, email, phone,company } = formData;

    // Check if required fields are empty
    if (!firstName || !lastName || !email || !phone || !company) {
      setSnackMessage("Please fill out all required fields (First Name, Last Name, Email, Phone,Company Name).");
      setSnackbarOpen(true)
      setSeverity("");
      return false;
    }

    // Validate email format
    if (!validateEmail(email)) {
      setSnackMessage("Please enter a valid email address.");
      setSnackbarOpen(true);
      setSeverity("");

      return false;
    }

    // Validate phone format
    if (!validatePhone(phone)) {
      setSnackMessage("Phone number must contain only numbers.");
      setSnackbarOpen(true);
      setSeverity("");

      return false;
    }

    // Validate first name and last name format
    if (!validateName(firstName) || !validateName(lastName)) {
      setSnackMessage("First Name and Last Name must contain only letters.");
      setSnackbarOpen(true);
      setSeverity("");

      return false;
    }

    return true; // All fields are valid
  };

  const validateCaseFields = () => {
    const { email, description, subject } = formData;
    if (!validateEmail(email)) {
      setSnackMessage("Please enter a valid email address.");
      setSnackbarOpen(true);
      setSeverity("");

      return false;
    }
    if (!subject) {
      setSnackMessage("Please provide a subject.");
      setSnackbarOpen(true);
      setSeverity("");
      return false;
    }
    if (!description) {
      setSnackMessage("Please provide a description.");
      setSnackbarOpen(true);
      setSeverity("");
      return false;
    }
    return true; // All fields are valid
  }
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Run validation only for "enquiry"
    if (selectedOption === "enquiry" && !validateFields()) {
      return; // Stop if validation fails
    }
    if (selectedOption === "case" && !validateCaseFields()) {
      return; // Stop if validation fails
    }

    try {
      // Check if there are any errors before submitting
      const hasErrors = Object.values(errors).some((error) => error !== "");
      if (hasErrors) {
        setSnackMessage("Please correct the errors before submitting.");
        setSnackbarOpen(true);
        setSeverity("");

        return;
      }
      setLoading(true)
      let payload = [];
      if (selectedOption === "enquiry") {
        payload = {
          tablename: "leads",
          data: {
            name: `${formData.firstName} ${formData.lastName}`,
            firstname: formData.firstName,
            lastname: formData.lastName,
            title: formData.title,
            origin: "Website",
          },
        };
      } else if (selectedOption === "case") {
        payload = {
          tablename: "cases",
          data: {
            name: formData.email,
            stage: "In Progress",
            description: formData.description,
          },
        };
      }

      const response = await submitFormAPI(payload);
      if (response.statusCode === 201) {
        setSnackbarOpen(true);
        setSnackMessage("Form submitted successfully")
        setSeverity("success");
      }
    } catch (exceptionalError) {
      console.error("An error occurred:", exceptionalError);
    }
    finally{
      setLoading(false);
    }

    // Log the form data (for debugging)
    console.log("Form Data:", { selectedOption, ...formData });

    // Reset the form fields
    setFormData({
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      phone: "",
      description: "",
      subject: "",
    });

    // Close the dialog
    handleClose();
  };
  return (
    <><ToastMessages
      isOpen={isSnackbarOpen}
      handleClose={() => setSnackbarOpen(false)}
      data={snackMessage}
      severity={severity} /><div style={styles.chatbotContainer}>
        {/* Chatbot Bubble */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: COLORS.primaryColor,
            "&:hover": {
              backgroundColor: COLORS.overlayColor,
            },
          }}
          style={styles.chatbotBubble}
          onClick={handleOpen}
        >
          <ModeCommentIcon />
        </Button>

        {/* Chatbot Popup */}
        <Dialog
          open={isOpen}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
          sx={{
            position: "fixed",
            bottom: "40px", // Adjust this value to position above the bubble
            right: { md: "-70%" },
            margin: 0,
            "& .MuiDialog-paper": {
              margin: 0, // Remove default margin
              width: { md: "15%" }, // Responsive width
              maxWidth: "none", // Override maxWidth
              backgroundColor: COLORS.whiteColor, // Match login page background
            },
          }}
        >
          <DialogTitle sx={{ color: COLORS.secondaryColor, fontWeight: "bold",fontFamily:fontFamilyAll }}>
            Chat Support
          </DialogTitle>
          <DialogContent>
            <p style={styles.message}>
              Sorry, all our chat agents are busy right now. Please let us know if
              you would like to:
            </p>

            <RadioGroup
              value={selectedOption}
              onChange={handleOptionChange}
              style={styles.radioGroup}
            >
              <FormControlLabel
                value="enquiry"
                control={<Radio
                  sx={{
                    color: COLORS.primaryColor,
                    "&.Mui-checked": { color: COLORS.secondaryColor },
                  }} />}
                label="Submit an Enquiry"
                sx={{
                  color: COLORS.secondaryColor,
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "'Nunito Sans', sans-serif",
                  },
                }} />
              <FormControlLabel
                value="case"
                control={<Radio
                  sx={{
                    color: COLORS.primaryColor,
                    "&.Mui-checked": { color: COLORS.secondaryColor },
                  }} />}
                label="Submit a Support Case"
                sx={{
                  color: COLORS.secondaryColor,
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "'Nunito Sans', sans-serif",
                  },
                }} />
            </RadioGroup>

            {/* Form Fields */}
            {selectedOption === "enquiry" && (
              <div style={styles.formContainer}>
                <div
                  style={{ width: "100%", display: "flex", alignItems: "center" }}
                >
                  <FormControl
                    sx={{
                      width: "25%",
                      marginTop: "10px",
                      marginRight: "10px"
                    }}
                    variant="outlined"
                  >
                    <InputLabel
                      id="demo-simple-select-label"
                      sx={{ color: COLORS.secondaryColor,fontFamily:fontFamilyAll }}
                    >
                      Title
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      label="Title"  // <-- Make sure the label is set here
                      sx={{
                        fontFamily:fontFamilyAll,
                        "& .MuiSelect-select": { color: COLORS.secondaryColor },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: COLORS.secondaryColor,
                        },
                        "& .MuiSvgIcon-root": { color: COLORS.secondaryColor },
                      }}
                    >
                      <MenuItem value={"Mr"}>Mr.</MenuItem>
                      <MenuItem value={"Mrs"}>Mrs.</MenuItem>
                      <MenuItem value={"Miss"}>Miss.</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    label="First Name"
                    fullWidth
                    margin="normal"
                    required
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                    sx={{
                      "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                      "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                      width: "75%",
                    }} />
                </div>
                <TextField
                  label="Last Name"
                  fullWidth
                  margin="normal"
                  required
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  margin="normal"
                  required
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
                <TextField
                  label="Company"
                  fullWidth
                  margin="normal"
                  required
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
                <TextField
                  label="Phone"
                  type="tel"
                  fullWidth
                  margin="normal"
                  required
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
                <TextField
                  label="Description"
                  multiline
                  rows={4}
                  fullWidth
                  margin="normal"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor ,fontFamily:fontFamilyAll,},
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
              </div>
            )}

            {selectedOption === "case" && (
              <div style={styles.formContainer}>
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  margin="normal"
                  required
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
                <TextField
                  label="Subject"
                  fullWidth
                  margin="normal"
                  required
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
                <TextField
                  label="Description"
                  multiline
                  rows={4}
                  fullWidth
                  margin="normal"
                  required
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  sx={{
                    "& .MuiInputLabel-root": { color: COLORS.secondaryColor,fontFamily:fontFamilyAll, },
                    "& .MuiOutlinedInput-root": { color: COLORS.secondaryColor },
                  }} />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              sx={{ color: COLORS.secondaryColor,fontFamily:fontFamilyAll, "&:hover": { color: COLORS.overlayColor } }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              sx={{
                backgroundColor: COLORS.secondaryColor,
                fontFamily:fontFamilyAll,
                color: "white",
                "&:hover": {
                  backgroundColor: COLORS.overlayColor,
                },
              }}
            >
              {loading  ? (
                <>
                  <CircularProgress size={10} color="inherit" style={{ marginRight: 8 }} />
                  Submit
                </>
              ) : (
                'Submit'
              )}
            </Button>
          </DialogActions>
        </Dialog>

      </div></>
  );
};

// Inline Styles
const styles = {
  chatbotContainer: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
  },
  chatbotBubble: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    minWidth: "unset",
    padding: "0",
    fontSize: "24px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  },
  message: {
    fontSize: "14px",
    color: COLORS.secondaryColor, // Match login page text color
    marginBottom: "20px",
  },
  radioGroup: {
    marginBottom: "20px",
  },
  formContainer: {
    marginTop: "10px",
  },
};

export default Chatbot;
